import { render, staticRenderFns } from "./CreateStaffPopUp.vue?vue&type=template&id=217a9f2a&scoped=true&"
import script from "./CreateStaffPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateStaffPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateStaffPopUp.vue?vue&type=style&index=0&id=217a9f2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217a9f2a",
  null
  
)

export default component.exports